export class LoginUserModel {
    access_token: string;
    token_type: string;
    refresh_token: string;
    expires_in: number;
    scope: string;
    name: string;
    employeeID: string;
    userName: string;
    avatar: string;
}
